import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router';

import { ApiError } from '../api/client.js';
import { ticketApi } from '../api/endpoints.js';
import { queryKeys } from '../app/query-client.js';
import { PageHeader } from '../components/page-header.js';
import { Spinner } from '../components/ui.js';

export function TicketLinkPage(): ReactNode {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.tickets.detail(id ?? 'none'),
    queryFn: () => ticketApi.get(id ?? ''),
    enabled: id !== undefined,
    retry: false,
  });

  if (id === undefined) return <Navigate to="/" replace />;

  if (isLoading) {
    return (
      <div className="grid flex-1 place-items-center text-muted">
        <Spinner className="size-5" />
      </div>
    );
  }

  if (error !== null || data === undefined) {
    const gone = error instanceof ApiError && error.status === 404;

    return (
      <>
        <PageHeader title="Request" />
        <div className="grid flex-1 place-items-center px-8 text-center">
          <p className="max-w-[42ch] text-[14px] text-muted">
            {gone
              ? 'That request is not available. It may have been deleted, or it may sit in a department you cannot see.'
              : 'That request could not be opened. Try again in a moment.'}
          </p>
        </div>
      </>
    );
  }

  return <Navigate to={`/boards/${data.boardSlug}?ticket=${data.id}`} replace />;
}
